import { Component, input } from '@angular/core';

/**
 * Any Material Icon name from https://fonts.googleapis.com/icon?family=Material+Icons
 * Examples: home, search, settings, delete, edit, add, close, check, etc.
 * See full list at: https://fonts.google.com/icons
 */
type MaterialIcon = string;

@Component({
  selector: 'htx-icon',
  standalone: true,
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  /**
   * The Material Icon name to display from https://fonts.googleapis.com/icon?family=Material+Icons
   * Examples: home, search, settings, delete, edit, add, close, check, etc.
   * See full list at: https://fonts.google.com/icons
   */
  icon = input<MaterialIcon | null>(null);
}
